var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPrivateBlue = function SvgPrivateBlue(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1366",
    "data-name": "Group 1366",
    transform: "translate(-60 -14)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1256",
    "data-name": "Rectangle 1256",
    width: 24,
    height: 24,
    transform: "translate(60 14)",
    fill: "rgb(25,100,174,0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-user-lock",
    "data-name": "Icon awesome-user-lock",
    d: "M7,8A4,4,0,1,0,3,4,4,4,0,0,0,7,8Zm3,2a1.971,1.971,0,0,1,.253-.953A4.277,4.277,0,0,0,9.8,9H9.278A5.44,5.44,0,0,1,4.722,9H4.2A4.2,4.2,0,0,0,0,13.2v1.3A1.5,1.5,0,0,0,1.5,16h8.778A1.986,1.986,0,0,1,10,15Zm9-1H18V6.5a2.5,2.5,0,0,0-5,0V9H12a1,1,0,0,0-1,1v5a1,1,0,0,0,1,1h7a1,1,0,0,0,1-1V10A1,1,0,0,0,19,9Zm-3.5,4.5a1,1,0,1,1,1-1A1,1,0,0,1,15.5,13.5Zm1-4.5h-2V6.5a1,1,0,0,1,2,0Z",
    transform: "translate(62 18)",
    fill: "#2a82f6"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPrivateBlue, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/private-blue.1744c977.svg";
export { ForwardRef as ReactComponent };